import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  messageContainsLinkNote,
  generateBodyErrorMessage,
  generateSubjectErrorMessage,
  generateTextMessageSplit,
  textMessageContainsLink,
} from "../../../MessageComponents/Constants/MessageConstants";
import { MessageInputType, MessageStateType } from "../../Typings/MessageState";
import { RootState } from "../Store";

export interface IEmailInput {
  body: string;
  bodyText: string;
}

const defaultInputMessageState: MessageStateType = {
  body: "",
  subject: "",
  activeInput: "body",
  messageType: "text",
  showTextSendMenu: false,
  touched: false,
};

export const MessageDialogInputSlice = createSlice({
  name: "messageDialogInput",
  initialState: defaultInputMessageState,
  reducers: {
    inputTextBody: (state, action: PayloadAction<string>) => {
      const bodyErrorMessage = generateBodyErrorMessage(action.payload, false, state.touched);
      const { textSplitCount, textSplitWarning } = generateTextMessageSplit(action.payload, false);
      const textContainsLink = textMessageContainsLink(action.payload, false);
      state.body = action.payload;
      state.bodyErrorMessage = bodyErrorMessage;
      state.textSplitCount = textSplitCount;
      state.textSplitWarning = textSplitWarning;
      state.textContainsLink = textContainsLink ? messageContainsLinkNote : "";
      state.touched = true;
    },
    inputEmailBody: (state, action: PayloadAction<IEmailInput>) => {
      const bodyErrorMessage = generateBodyErrorMessage(action.payload.bodyText, true, state.touched);
      state.body = action.payload.body;
      state.bodyErrorMessage = bodyErrorMessage;
      state.touched = true;
    },
    inputEmailSubject: (state, action: PayloadAction<string>) => {
      const subjectErrorMessage = generateSubjectErrorMessage(action.payload);
      state.subject = action.payload;
      state.subjectErrorMessage = subjectErrorMessage;
    },
    resetMessageBody: (state) => {
      state.body = "";
      state.bodyErrorMessage = undefined;
      state.textSplitCount = undefined;
      state.textSplitWarning = undefined;
      state.textContainsLink = undefined;
      state.touched = false;
    },
    resetSubject: (state) => {
      state.subject = "";
      state.subjectErrorMessage = undefined;
    },
    closeSendMenu: (state) => {
      state.showTextSendMenu = false;
    },
    openSendMenu: (state) => {
      state.showTextSendMenu = true;
    },
    setMessageType: (state, action: PayloadAction<MessageInputType>) => {
      state.messageType = action.payload;
    },
    initializeMessageDialogInput: (state, action: PayloadAction<MessageStateType>) => {
      state.body = action.payload.body;
      state.subject = action.payload.subject;
      state.messageType = action.payload.messageType;
    },
  },
});
// Action creators are generated for each case reducer function
export const {
  inputTextBody,
  inputEmailBody,
  inputEmailSubject,
  initializeMessageDialogInput,
  resetMessageBody,
  resetSubject,
  closeSendMenu,
  openSendMenu,
  setMessageType,
} = MessageDialogInputSlice.actions;

export const selectInputMessageState = (state: RootState) => state.messageDialogInput;
export const selectInputMessageBody = (state: RootState) => state.messageDialogInput.body;
export const selectInputMessageSubject = (state: RootState) => state.messageDialogInput.subject;

export default MessageDialogInputSlice.reducer;
